import { TimelineItemContentBadgeTypeT } from 'components/Timeline/types'
import { TIMELINE_BADGE_VARIANTS } from 'redesign/components/molecules/timeline-badge/constants'
import {
  NEXT_MONTH_MANAGER_TEXTS,
  THIS_MONTH_MANAGER_TEXTS,
} from '../monthly-sheet-details/utils/manager-action-buttons/constants'

export const ABSENCE_REQUEST_BADGES = {
  [TimelineItemContentBadgeTypeT.absenceRequested]: {
    variant: TIMELINE_BADGE_VARIANTS.warning,
    text: 'badge.requested',
    testId: 'task-status_absence-requested',
    managerTooltip: 'absenceRequest.absenceRequested.tooltipManager',
    frontlinerTooltip: 'absenceRequest.absenceRequested.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.absenceRequestAccepted]: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'badge.accepted',
    testId: 'task-status_absence-accepted',
    managerTooltip: 'absenceRequest.absenceAccepted.tooltipManager',
    frontlinerTooltip: 'absenceRequest.absenceAccepted.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.deletionConfirmed]: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'badge.deletionConfirmed',
    testId: 'task-status_deletion-confirmed',
    managerTooltip: 'absenceRequest.deletionConfirmed.tooltipManager',
    frontlinerTooltip: 'absenceRequest.deletionConfirmed.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.absenceRequestRejected]: {
    variant: TIMELINE_BADGE_VARIANTS.error,
    text: 'badge.rejected',
    testId: 'task-status_absence-rejected',
    managerTooltip: 'absenceRequest.absenceRejected.tooltipManager',
    frontlinerTooltip: 'absenceRequest.absenceRejected.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.deletionDenied]: {
    variant: TIMELINE_BADGE_VARIANTS.error,
    text: 'badge.rejected',
    testId: 'task-status_deletion-denied',
    managerTooltip: 'absenceRequest.deletionDenied.tooltipManager',
    frontlinerTooltip: 'absenceRequest.deletionDenied.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.deletionRequest]: {
    variant: TIMELINE_BADGE_VARIANTS.warning,
    text: 'badge.deletionRequested',
    testId: 'task-status_deletion-request',
    managerTooltip: 'absenceRequest.deletionRequest.tooltipManager',
    frontlinerTooltip: 'absenceRequest.deletionRequest.tooltipFrontliner',
  },
} as const

export const MONTHLY_SHEET_BADGES = {
  [TimelineItemContentBadgeTypeT.workTimeAccepted]: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'badge.accepted',
    testId: 'task-status_work-time-accepted',
    managerTooltip: 'workTimeControl.workTimeAccepted.tooltipManager',
    frontlinerTooltip: 'workTimeControl.workTimeAccepted.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.wtcChangeRequest]: {
    variant: TIMELINE_BADGE_VARIANTS.warning,
    text: 'badge.changeRequested',
    testId: 'monthly-sheet-detail_claim_badge',
    managerTooltip: 'workTimeControl.requestedChange.tooltipManager',
    frontlinerTooltip: 'workTimeControl.requestedChange.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.acceptedForThisMonth]: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'badge.changeThisMonth',
    testId: 'task-status_claim-accepted-this-month',
    managerTooltip: 'workTimeControl.acceptedForThisMonth.tooltipManager',
    frontlinerTooltip: 'workTimeControl.acceptedForThisMonth.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.acceptedForNextMonth]: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'badge.changeNextMonth',
    testId: 'task-status_claim-accepted-next-month',
    managerTooltip: 'workTimeControl.acceptedForNextMonth.tooltipManager',
    frontlinerTooltip: 'workTimeControl.acceptedForNextMonth.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.rejected]: {
    variant: TIMELINE_BADGE_VARIANTS.error,
    text: 'badge.rejected',
    testId: 'task-action-rejected',
    managerTooltip: '',
    frontlinerTooltip: '',
  },
} as const

export const SHARE_USER_DATA_BADGES = {
  [TimelineItemContentBadgeTypeT.sharedPersonalData]: {
    variant: TIMELINE_BADGE_VARIANTS.warning,
    text: 'badge.dataShared',
    testId: 'task-status_shared-personal-data',
    managerTooltip: 'shareUserData.sharedPersonalData.tooltipManager',
    frontlinerTooltip: 'shareUserData.sharedPersonalData.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.dataValidatedAndAccepted]: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'badge.dataTransferred',
    testId: 'task-status_data-validated-and-accepted',
    managerTooltip: 'shareUserData.dataValidatedAndAccepted.tooltipManager',
    frontlinerTooltip: 'shareUserData.dataValidatedAndAccepted.tooltipFrontliner',
  },
} as const

export const SECURE_CONNECTION_BADGES = {
  [TimelineItemContentBadgeTypeT.invitationAccepted]: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'badge.invitationAccepted',
    testId: 'task-status_invitation-accepted',
    managerTooltip: 'secureConnection.invitationAccepted.tooltipManager',
    frontlinerTooltip: 'secureConnection.invitationAccepted.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.identificationStarted]: {
    variant: TIMELINE_BADGE_VARIANTS.warning,
    text: 'badge.identificationStarted',
    testId: 'task-status_identification-started',
    managerTooltip: 'secureConnection.identificationStarted.tooltipManager',
    frontlinerTooltip: 'secureConnection.identificationStarted.tooltipFrontliner',
  },
  [TimelineItemContentBadgeTypeT.identificationVerified]: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'badge.verified',
    testId: 'task-status_identification-verified',
    managerTooltip: 'secureConnection.identificationVerified.tooltipManager',
    frontlinerTooltip: 'secureConnection.identificationVerified.tooltipFrontliner',
  },
} as const

export const COMMENT_BADGES = {
  ['accept_next_month_manager_badge']: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: NEXT_MONTH_MANAGER_TEXTS.acceptBadgeText,
    testId: 'monthly-sheet-accept-next-month',
    managerTooltip: NEXT_MONTH_MANAGER_TEXTS.acceptBadgeTooltipText,
    frontlinerTooltip: NEXT_MONTH_MANAGER_TEXTS.acceptBadgeTooltipText,
  },
  ['accept_this_month_manager_badge']: {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: THIS_MONTH_MANAGER_TEXTS.acceptBadgeText,
    testId: 'monthly-sheet-accept-this-month',
    managerTooltip: THIS_MONTH_MANAGER_TEXTS.acceptBadgeTooltipText,
    frontlinerTooltip: THIS_MONTH_MANAGER_TEXTS.acceptBadgeTooltipText,
  },
} as const

export const BADGE_PROPS = {
  ...ABSENCE_REQUEST_BADGES,
  ...MONTHLY_SHEET_BADGES,
  ...SHARE_USER_DATA_BADGES,
  ...SECURE_CONNECTION_BADGES,
} as const

export const ABSENCE_REQUEST_BADGE_TYPES = [
  TimelineItemContentBadgeTypeT.absenceRequestAccepted,
  TimelineItemContentBadgeTypeT.absenceRequested,
]
